﻿import { IBinder, IBehaviorBinding, ICellBinding } from "./ibinder";
import Utility from "../utility";
import { Remote } from "../../remote/remote";
import $ from 'jquery';
import ko from 'knockout';

export class RemoteOnChangeBinder implements IBinder {
  public getElements(root: JQuery): JQuery {
    return root.find(":input[data-url]");
  }

  public getBinding(element: JQuery): IBehaviorBinding {
    return {
      bindingName: "event",
      bindTo: "{change: $parent.remote}",
      createEmptyValue: () => null,
      behavior: {
        name: "remote",
        build: data => (item, event) => {
          var $el = $(event.currentTarget);
          var remoteKeys = $el.attr("data-et-remote-keys");
          if (remoteKeys) {
            var dataKeysToSend = remoteKeys.split(",");
            var dataToSend = {};
            dataKeysToSend.forEach(key => {
              var _key = key.trim();
              var name = Utility.relativeName(_key);
              dataToSend[name] = ko.utils.unwrapObservable(item[name]);
            });

            $el.data("et-additional-values", dataToSend);
          }
          $el.remote();
          return true;
        }
      }
    }
  }
}
